import styled, { css } from 'styled-components';
import Sider from 'antd/lib/layout/Sider';
import { Menu } from 'antd';

export const Container = styled(Sider)`
    && {
        ${({ theme, collapsed }) => css`
            overflow-y: scroll;
            background-color: ${theme.colors.white};
            border-right: 1px solid ${theme.colors.lightGrey};
            overflow-y: auto;
            overflow-x: hidden;

            .ant-menu-title-content .ant-menu-submenu-arrow {
                display: ${collapsed ? 'none' : 'inline'};
            }
            .ant-menu-item-selected {
                color: ${theme.colors.accentColor};
            }
            .ant-menu-item::after {
                border: 1px solid ${theme.colors.accentColor};
            }

            ::-webkit-scrollbar {
                display: none;
            }
        `}
    }
`;

export const Version = styled.span`
    display: flex;
    justify-content: center;
    font-size: 1.1rem;
    color: lightgrey;
    font-weight: bold;
`;

export const Icon = styled.img`
    width: 14px;
    height: 14px;
    margin-right: 10px;
    margin-bottom: 4px;
`;

export const MenuScrollHidden = styled.div`
    height: calc(100% - 57px);
    overflow-y: auto;

    scrollbar-width: none;

    -ms-overflow-style: none;

    &::-webkit-scrollbar {
        display: none;
    }
`;
